import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectPlantillaCobranza } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const PlantillaCobranzaFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('date-fechaPago', e)
  }, [])

  const onChange = React.useCallback(
    e => {
      const nuevoValor = e.target.value
      if (nuevoValor) {
        setFieldValue('cuentaContablePago', nuevoValor)
        setFieldValue('monedaPago', e.moneda)
      } else {
        setFieldValue('cuentaContablePago', '')
        setFieldValue('monedaPago', 'SOLES')
      }
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='CUENTA' htmlFor='select-plantillaCobranza' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idPartida'>
          {({ field }) => (
            <SelectPlantillaCobranza
              {...field}
              showNewButton
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onChange={onChange}
              id='select-plantillaCobranza'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlantillaCobranzaFormGroup)
